import React, { useState } from 'react';
import { FormHelperText, InputAdornment, TextField, Typography } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import { useDispatch } from 'react-redux';
import { addDocter } from '../../store/actions/dokterAction';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import changeImage from '../../assets/changeImage.png';
import editProf from '../../assets/editProf.png';
import profile from '../../assets/profile.png';
import api from '../api';
import ImageUploader from 'react-images-upload';
import Autocomplete from '@material-ui/lab/Autocomplete';
import UploadFileImage from '../components/UploadFileImage';

export default function AddDocter(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [poli, setListPoli] = useState([])
    const [uploadVisible, setUploadVisible] = useState(false)
    const [photo, setPhoto] = useState("")
    const [poliklinik, setPoliklinik] = useState(null)
    // const [referalVclaim, setReferalVclaim] = useState("")
    // const [referalHfis, setReferalHfis] = useState("")
    const [time, setTime] = useState(null)
    const [image, setImage] = useState([profile])
    const [pictures, setPicture] = useState([])
    const [newDocter, setnewDocter] = useState({
        kodeDokter: "",
        alamat: "",
        durasiperiksa: "",
        namaDokter: "",
        tahunAktif: "",
        noSTR: "",
        graduate: "",
        keteranganDokter: "",
        noTelp: "",
        kodeAntrian: "",
        referalVclaim: "",
        referalHfis: ""

    })
    const listSesi = [
        { name: "Tidak", id: 0 },
        { name: "Ya", id: 1 },
    ]
    const [prefixSesi, setPrefixSesi] = useState(listSesi[0])

    const listIGD = [
        { name: "Tidak", id: 0 },
        { name: "Ya", id: 1 },
    ]

    const [igd, setIGD] = useState(listIGD[0])
    const [percentage, setpercentage] = useState('0')
    const [uploadstatus, setuploadstatus] = useState("")
    const [result, setresult] = useState("")

    const fileHandler = (event) => {
        console.log(event);
        if (event) {
            let images = URL.createObjectURL(event)
            setPhoto(images)
            setPicture([event])
            console.log(images);
        }
    }

    const [errorPoli, setErrorPoli] = useState(false)
    const [textkodeDokter, setTextKodeDokter] = React.useState("");
    const [errorKodeDokter, setErrorKodeDokter] = React.useState(false);
    const [textNama, setTextNama] = React.useState("");
    const [errorNama, setErrorNama] = React.useState(false);
    const [textNoSTR, setTextNoSTR] = React.useState("");
    const [errorNoSTR, setErrorNoSTR] = React.useState(false);
    const [textNoTelp, setTextNoTelp] = React.useState("");
    const [errorNoTelp, setErrorNoTelp] = React.useState(false);
    const [textKodeAntrian, setTextKodeAntrian] = React.useState("");
    const [errorKodeAntrian, setErrorKodeAntrian] = React.useState(false);
    const [textGraduate, setTextGraduate] = React.useState("");
    const [errorGraduate, setErrorGraduate] = React.useState(false);
    const [textTahunAktif, setTextTahunAktif] = React.useState("");
    const [errorTahunAktif, setErrorTahunAktif] = React.useState(false);
    const [phone, setPhone] = useState("")
    const [textPhone, setTextPhone] = React.useState("");
    const [errorPhone, setErrorPhone] = React.useState(false);

    const forceUpdate = React.useReducer(bool => !bool)[1];


    React.useEffect(() => {
        getDataPoli()
    }, [])

    const handleOnChange = (e) => {
        const { name, value } = e.target
        setnewDocter({
            ...newDocter,
            [name]: value
        })
    }

    const getDataPoli = (value) => {
        if (value === undefined || value === "") {
            api.create().getListPoli(value === undefined ? "" : value).then(response => {
                console.log(response)
                if (response.data) {
                    let listPoli = []
                    response.data.data.map((item, index) => {
                        if (item.deleted_at === null) {
                            listPoli.push({
                                id: item.id,
                                name: String(item.name).trim()
                            })
                        }
                    })
                    setListPoli(listPoli)
                }
            })
        }
    }


    const doSubmit = (e) => {
        let regName = /^[a-zA-Z\s]+$/
        let regAlpha = /^[a-zA-Z]+$/
        let regNumber = /^[0-9]+$/
        if (newDocter.kodeDokter === "") {
            setTextKodeDokter("Kode Dokter Harus Diisi")
            setErrorKodeDokter(true)
            // } else if (newDocter.noSTR === "") {
            //     setTextNoSTR("No STR Harus Diisi")
            //     setErrorNoSTR(true)
        } else if (newDocter.namaDokter === "") {
            setTextNama("Nama Harus Diisi")
            setErrorNama(true)
        } else if (newDocter.kodeAntrian === "") {
            setTextKodeAntrian("Kode Antrian Harus Diisi")
            setErrorKodeAntrian(true)
        }
        // else if (regNumber.test(newDocter.namaDokter)) {
        //     setTextNama("Nama tidak boleh berisi angka")
        //     setErrorNama(true)
        // }
        // else if (!regNumber.test(newDocter.noSTR)) {
        //     setTextNoSTR("No STR Harus Berisi Angka")
        //     setErrorNoSTR(true)
        // } 
        else if (poliklinik === null) {
            setErrorPoli(true)
            // } else if (newDocter.graduate === "") {
            //     setTextGraduate("Lulusan Harus Diisi")
            //     setErrorGraduate(true)
            // } else if (newDocter.tahunAktif === "") {
            //     setTextTahunAktif("Tahun Aktif Harus Diisi")
            //     setErrorTahunAktif(true)
        } else {
            let pic = pictures[0]
            let poli = []
            if (poliklinik !== null) {
                poliklinik.map(item => {
                    poli.push(item.id)
                })
            }
            let formData = new FormData()
            formData.append('dr_code', newDocter.kodeDokter)
            formData.append('str_no', newDocter.noSTR)
            formData.append('desc', newDocter.keteranganDokter)
            formData.append('polyclinic_id', JSON.stringify(poli))
            formData.append('name', newDocter.namaDokter)
            console.log(newDocter.tahunAktif);
            formData.append('graduate', newDocter.graduate)
            if (newDocter.tahunAktif !== "") {
                formData.append('start_year', newDocter.tahunAktif)
            }
            formData.append('use_doctor_session_queue', prefixSesi.id)
            formData.append('is_igd', igd.id)
            formData.append('phone', newDocter.noTelp)
            formData.append('queue_code', newDocter.kodeAntrian)
            formData.append('bpjs_vclaim_reference_code', newDocter.referalVclaim)
            formData.append('bpjs_hfis_reference_code', newDocter.referalHfis)
            if (pic !== undefined) {
                formData.append('photo', pic)
            }
            console.log(...formData);
            api.create().createDokter(formData).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        props.onClose()
                        props.getData()
                    } else {
                        if (response.data.data.str_no) {
                            alert(response.data.data.str_no)
                        } else if (response.data.data.dr_code) {
                            alert(response.data.data.dr_code)
                        } else {
                            alert(response.data.message)
                        }
                    }
                }
            })
        }
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------1');
        console.log(pictureFiles);
        setPhoto(pictureDataURLs)
        setPicture(pictureFiles)
        // console.log(response);
        // console.log(pictureDataURLs);
        // this.setState({
        //     pictures: this.state.pictures.concat(pictureFiles),
        // });
    }

    const uploadFoto = () => {
        // console.log(pictures[0].name, '================2');
        // api.create().uploadFoto(pictures[0].name).then(response => {
        //     console.log(response);
        // })
        setUploadVisible(false)
    }

    const handleSpesialis = (value) => {
        // setSpesialis(value)
        // setKeywordSpesialis({ keywordSpesialis: value !== null ? value.name : "" })
        // console.log(keywordSpesialis);
        // getDataPoli()
    }


    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Tambah Dokter Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ margin: 'auto', width: 134, height: 134, backgroundColor: photo === "" ? 'green' : 'transparent', marginTop: 20, borderRadius: 80 }}>
                    <img src={photo === "" ? image : photo} style={{ width: 126, height: 126, marginTop: 3, borderRadius: 60 }} />
                    <div style={{ marginTop: -19, marginLeft: 7 }}>
                        <img src={changeImage} style={{ width: 102, height: 24, marginRight: 8 }} />
                        <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer' }}
                            onClick={(e) => {
                                setPicture("")
                                setUploadVisible(true)
                            }}
                        />
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="kodeDokter"
                                name="kodeDokter"
                                label="Kode Dokter"
                                required={true}
                                error={errorKodeDokter}
                                helperText={textkodeDokter}
                                placeholder={"kode dokter"}
                                onChange={(e) => {
                                    handleOnChange(e)
                                    setErrorKodeDokter(false)
                                    setTextKodeDokter("")
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="namaDokter"
                                name="namaDokter"
                                label="Nama Dokter"
                                required={true}
                                error={errorNama}
                                helperText={textNama}
                                placeholder={"input nama dokter"}
                                onChange={(e) => {
                                    let regNumber = /^[0-9]+$/
                                    // if (!regNumber.test(e.target.value)) {
                                    //     setTextNama("Nama tidak boleh berisi angka")
                                    //     setErrorNama(true)
                                    // }
                                    setErrorNama(false)
                                    setTextNama("")
                                    handleOnChange(e)
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="noHp"
                                name="noTelp"
                                label="No. Handphone Dokter"
                                error={errorNoTelp}
                                helperText={textNoTelp}
                                placeholder={"input No. Handphone dokter"}
                                onChange={(e) => {
                                    setTextNoTelp("")
                                    setErrorNoTelp(false)
                                    handleOnChange(e)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    maxLength: 12
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    },
                                    startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5 }}>+62</InputAdornment>,
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.noTelp}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="kodeAntrian"
                                name="kodeAntrian"
                                label="Kode Antrian"
                                placeholder={"Input Kode Antrian"}
                                required
                                error={errorKodeAntrian}
                                helperText={textKodeAntrian}
                                onChange={(e) => {
                                    setTextKodeAntrian("")
                                    setErrorKodeAntrian(false)
                                    handleOnChange(e)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    maxLength: 2
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                multiple
                                options={poli}
                                getOptionLabel={(option) => option.name}
                                debug
                                name='poliklinik'
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setPoliklinik(newInputValue)
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Klinik"
                                    />
                                }
                            />
                            {errorPoli && (
                                <FormHelperText style={{ color: 'red' }}>Poliklinik Tidak Boleh Kosong</FormHelperText>
                            )}
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                options={listIGD}
                                getOptionLabel={(option) => option.name}
                                disableClearable
                                onChange={(event, newInputValue) => {
                                    setIGD(newInputValue)
                                }}
                                value={igd}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Dokter IGD"
                                    />
                                }
                            />
                        </div>
                        <TextField
                            style={{ width: '100%', marginTop: 15 }}
                            id="referalHfis"
                            name="referalHfis"
                            label="Kode Referensi HFIS"
                            placeholder={"Input Kode Referensi HFIS"}
                            onChange={(e) => {
                                handleOnChange(e)
                                forceUpdate()
                            }}
                            // inputProps={{
                            //     maxLength: 2
                            // }}
                            InputProps={{
                                style: {
                                    fontSize: 14,
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                        />
                    </div>

                    <div className="column-2">
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="noSTR"
                                name="noSTR"
                                label="No STR"
                                error={errorNoSTR}
                                helperText={textNoSTR}
                                placeholder={"input No STR"}
                                onChange={(e) => {
                                    setErrorNoSTR(false)
                                    setTextNoSTR("")
                                    handleOnChange(e)
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="graduate"
                                name="graduate"
                                label="Lulusan"
                                error={errorGraduate}
                                helperText={textGraduate}
                                placeholder={"input Lulusan"}
                                onChange={(e) => {
                                    setErrorGraduate(false)
                                    setTextGraduate("")
                                    handleOnChange(e)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="tahunAktif"
                                name="tahunAktif"
                                label="Tahun Aktif"
                                error={errorTahunAktif}
                                helperText={textTahunAktif}
                                placeholder={"Input Tahun Aktif"}
                                onChange={(e) => {
                                    setTextTahunAktif("")
                                    setErrorTahunAktif(false)
                                    handleOnChange(e)
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="keteranganDokter"
                                name="keteranganDokter"
                                label="Keterangan Dokter"
                                multiline
                                placeholder={"input Keterangan Dokter"}
                                onChange={(e) => {
                                    handleOnChange(e)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                options={listSesi}
                                getOptionLabel={(option) => option.name}
                                disableClearable
                                onChange={(event, newInputValue) => {
                                    setPrefixSesi(newInputValue)
                                }}
                                value={prefixSesi}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Prefix Antrian Sesi Dokter"
                                    />
                                }
                            />
                        </div>
                        <TextField
                            style={{ width: '100%', marginTop: 15 }}
                            id="referalVclaim"
                            name="referalVclaim"
                            label="Kode Referensi VCLAIM"
                            placeholder={"Input Kode Referensi VCLAIM"}
                            onChange={(e) => {
                                handleOnChange(e)
                                forceUpdate()
                            }}
                            // inputProps={{
                            //     maxLength: 2
                            // }}
                            InputProps={{
                                style: {
                                    fontSize: 14,
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => doSubmit(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {uploadVisible && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setUploadVisible(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        {photo !== "" && (
                            <div style={{ padding: 20 }}>
                                <img src={photo} style={{ height: 180 }}></img>
                            </div>
                        )}
                        <UploadFileImage
                            type={uploadstatus}
                            percentage={percentage}
                            result={result}
                            acceptedFiles={["JPG", "JPEG", "PNG", "GIF"]}
                            onHandle={(dt) => {
                                fileHandler(dt)
                                // setuploadstatus('idle')
                                // setpercentage('0')
                            }}
                            onUpload={() => {
                                setUploadVisible(false)
                                // isUpload && checkPreview()
                                // this.uploadAttachment(this.state.formData)
                            }}
                        />
                        {/* <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            fileSizeError={"Ukuran File melebihi 1 Mb"}
                            accept={"accept=image/*"}
                            fileTypeError={"Ekstensi tidak mendukung"}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.JPG']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        />
                        {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => uploadFoto()}>Upload</span>
                                </div>
                            </div> : null
                        } */}
                    </div>
                </div>
            )}
        </div>
    )
}